import { createSlice } from "@reduxjs/toolkit";
import { FLUTTER_BROADCAST_MODAL_SLICE_NAME } from "../sliceConstants";

const initialState = {
  open: false,
  notification: null,
};

export const flutterBroadcastModalSlice = createSlice({
  name: FLUTTER_BROADCAST_MODAL_SLICE_NAME,
  initialState,
  reducers: {
    openFlutterBroadcastModal: (_state, action) => ({
      open: true,
      notification: action.payload,
    }),
    closeFlutterBroadcastModal: () => initialState,
  },
});

export const {
  openFlutterBroadcastModal,
  closeFlutterBroadcastModal,
} = flutterBroadcastModalSlice.actions;

export default flutterBroadcastModalSlice.reducer;